'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'skull-crossbones';
var width = 448;
var height = 512;
var aliases = [128369,9760];
var unicode = 'f714';
var svgPathData = 'M302.1 232.7c31.2-21.1 49.9-53.5 49.9-88.7 0-58.8-54.1-112-128-112S96 85.2 96 144c0 35.2 18.7 67.6 49.9 88.7 8.8 6 14.1 15.9 14.1 26.5l0 12.8c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-12.8c0-10.6 5.3-20.6 14.1-26.5zM320 272c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-12.8C89.1 232.9 64 191.1 64 144 64 64.5 135.6 0 224 0S384 64.5 384 144c0 47.1-25.1 88.9-64 115.2l0 12.8zM1.5 329.3c3.7-8 13.2-11.5 21.2-7.8L224 414.4 425.3 321.5c8-3.7 17.5-.2 21.2 7.8s.2 17.5-7.8 21.2L262.2 432 438.7 513.5c8 3.7 11.5 13.2 7.8 21.2s-13.2 11.5-21.2 7.8L224 449.6 22.7 542.5c-8 3.7-17.5 .2-21.2-7.8s-.2-17.5 7.8-21.2L185.8 432 9.3 350.5c-8-3.7-11.5-13.2-7.8-21.2zM152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSkullCrossbones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;